import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import './App.css';
import './styles/common.css'; 
import { reportWebVitals, measurePageLoad } from './utils/webVitals';

const Cennik = lazy(() => import('./pages/Cennik/Cennik'));
const ONas = lazy(() => import('./pages/O-nas/O-nas'));
const Oferta = lazy(() => import('./pages/Oferta/Oferta'));
const Kontakt = lazy(() => import('./pages/Kontakt/Kontakt'));
const Certyfikaty = lazy(() => import('./pages/Certyfikaty/Certyfikaty'));
const PolitykaCookies = lazy(() => import('./pages/PolitykaCookies/PolitykaCookies'));
const PrzepisyRodo = lazy(() => import('./pages/PrzepisyRodo/PrzepisyRodo'));
const PrawaPacjenta = lazy(() => import('./pages/PrawaPacjenta/PrawaPacjenta'));
const DlaPacjenta = lazy(() => import('./pages/DlaPacjenta/DlaPacjenta'));
const Choszczno = lazy(() => import('./pages/Choszczno/Choszczno'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));

const App: React.FC = () => {
  useEffect(() => {
    reportWebVitals();
    measurePageLoad();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <Layout>
          <Suspense fallback={<div style={{padding: '20px', textAlign: 'center'}}>Ładowanie...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cennik" element={<Cennik />} />
              <Route path="/o-nas" element={<ONas />} />
              <Route path="/oferta" element={<Oferta />} />
              <Route path="/certyfikaty" element={<Certyfikaty />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/informacje-dla-pacjenta" element={<DlaPacjenta />} />
              <Route path="/polityka-cookies" element={<PolitykaCookies />} />
              <Route path="/informacje-rodo" element={<PrzepisyRodo />} />
              <Route path="/prawa-pacjenta" element={<PrawaPacjenta />} />
              <Route path="/fizjoterapia-choszczno" element={<Choszczno />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </Router>
    </HelmetProvider>
  );
};

export default App;
